export default __webpack_public_path__ + "static/media/english-to-hindi-screenshot-01.d72eeb2b.png";